(function () {
  // Skip in Shopify editor — animations interfere with live section editing
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  // Respect user preference — exit cleanly, CSS fallback handles safety
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Enable CSS motion states (hidden initial states activate via this class)
  document.documentElement.classList.add('gac-motion-ready');

  // Reveal elements as they enter the viewport
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -32px 0px'
    }
  );

  document.querySelectorAll('.gac-reveal').forEach(function (el) {
    observer.observe(el);
  });
})();

// Transparent header: measure announcement bar height, offset fixed header, toggle solid state
;(function () {
  if (!document.body.classList.contains('template-index')) return;

  // Measure the announcement bar and expose its height as a CSS variable so the
  // fixed header can sit below it. Re-measures on resize for wrapping bar text.
  var bar = document.getElementById('shopify-section-announcement_bar_6x4n3x');
  var barH = 0;
  function measureBar() {
    barH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--gac-bar-height', barH + 'px');
  }
  measureBar();
  window.addEventListener('resize', measureBar, { passive: true });

  // Go solid after scrolling 60px past the hero top edge (hero starts at barH in the flow)
  var solid = false;
  function update() {
    var shouldBeSolid = window.scrollY > barH + 60;
    if (shouldBeSolid !== solid) {
      solid = shouldBeSolid;
      document.body.classList.toggle('gac-header-solid', solid);
    }
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
